import React from "react";
import { Route, useHistory } from "react-router-dom";

const AdminRoute = ({ children, ...rest }) => {
  const history = useHistory();
  const user = JSON.parse(window.sessionStorage.getItem("user"));
  return (
    <>{user && user.usertype === 1 ? <Route {...rest} /> : history.push("/")}</>
  );
};

export default AdminRoute;
